import React from "react";
import { useTheme } from "../Providers/ThemeContext";

const Rules = () => {
  const { colors } = useTheme();

  return (
    <>
      <button
        style={{
          color: colors.secondary,
          backgroundColor: colors.background,
        }}
        className="hover:underline "
        onClick={() =>
          window.open("https://imagigeeks.org/rules.pdf", "_blank")
        }
      >
        Voir le règlement !
      </button>
    </>
  );
};

export default Rules;
